import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/RecommendationCategorys`;

export const createRecommendationCategory = async recommendationCategory => {
  const url = `${baseRoute}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(recommendationCategory),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const updateRecommendationCategory = async recommendationCategory => {
  const url = `${baseRoute}/${recommendationCategory.recommendationCategoryId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(recommendationCategory),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getRecommendationCategoryById = async recommendationCategoryId => {
  const url = `${baseRoute}/${recommendationCategoryId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getrecommendationCategorys = async () => {
  const url = `${baseRoute}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const removeRecommendationCategoryById = async recommendationCategoryId => {
  const url = `${baseRoute}/${recommendationCategoryId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'DELETE',
    headers,
    // body: JSON.stringify(recommendationCategory),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};
